var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.getClass,style:(_vm.style)},[_vm._v(" "+_vm._s(_vm.value === 0 ? "Нет" : _vm.value === 1 ? "Да" : null)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }